import { create } from 'zustand'

/** Bumped on device PersonalEvents so an open Admin → Devices screen reloads. */
export const useAdminDevices = create<{ revision: number }>(() => ({ revision: 0 }))

export function bumpAdminDevices(): void {
  useAdminDevices.setState((s) => ({ revision: s.revision + 1 }))
}
